
import * as z from "zod";
import { validatePhoneNumber, validateEmail } from "@/utils/sanitization";

export const ServiceContactSchema = z.object({
  name: z.string()
    .min(2, "Name is required and must be at least 2 characters")
    .max(100, "Name must be less than 100 characters")
    .transform(val => val.trim()),
  email: z.string()
    .min(1, "Email is required")
    .email("Please enter a valid email address")
    .refine(validateEmail, "Please enter a valid email address"),
  phone: z.string()
    .min(1, "Phone number is required")
    .refine(validatePhoneNumber, "Please enter a valid phone number"),
  message: z.string()
    .max(500, "Message must be less than 500 characters")
    .optional()
    .transform(val => val ? val.trim() : ""),
});

export type ServiceContactFormValues = z.infer<typeof ServiceContactSchema>;

export interface ServiceContactSubmission extends ServiceContactFormValues {
  serviceName?: string;
  pageUrl: string;
}
